import { Box, Chip, Grid, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { WishlistItemCard } from '../../components/wishlist-item-card/WishlistItemCard';
import { StrOrNum } from '../../types/util';
import { applyScreenStyles } from './styles';
import { ScholarshipApplyItemWithProgram } from './types';

interface ApplyProgramSelectProps {
  scholarship: ScholarshipApplyItemWithProgram;
  onChangeProgram: (programId: StrOrNum) => void;
  onCloseBtnClick: () => void;
  onApply: () => void;
}
const ApplyProgramSelect: React.FC<ApplyProgramSelectProps> = ({
  scholarship,
  onChangeProgram,
  onCloseBtnClick,
  onApply,
}) => {
  const applicablePrograms = scholarship.programs.filter(
    (program) => program.is_applicable && program.is_published && program.providers.is_published
  );

  // Sorting programs to show applicable programs first
  const programs = scholarship.programs.slice().sort((program) => {
    if (program.is_applicable && program.is_published && program.providers.is_published) {
      return -1;
    }
    return 1;
  });

  const hasApplicablePrograms = applicablePrograms.length > 0;

  return (
    <>
      <DialogTitle color={hasApplicablePrograms ? undefined : 'error'}>
        {hasApplicablePrograms
          ? 'Select a program you want to apply your scholarship for:'
          : 'None of the programs associated to this scholarship cannot be used for application. You cannot apply to this scholarship.'}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ py: 2 }}>
          <Grid container spacing={2}>
            {programs.map((program) => {
              const canUseProgramForApply =
                program.is_applicable && program.is_published && program.providers.is_published;
              return (
                <Grid item xs={12} md={6} key={program.id}>
                  <WishlistItemCard
                    sx={applyScreenStyles.programSelectCard}
                    hideField={!canUseProgramForApply}
                    FieldProps={{
                      checked: scholarship.selectedProgramId?.toString() === program.id.toString(),
                      onChange: () => onChangeProgram(program.id),
                    }}
                    type="institute_programs"
                    itemFormType="radio"
                    info={program.providers.address}
                    title={program.name}
                    subHeading={program.providers.name}
                    moduleId={program.id}
                    hideWishlistBtn
                  >
                    {!canUseProgramForApply && (
                      <Chip sx={{ mt: 1 }} variant="light" color="error" label="Inapplicable or unpublished program" />
                    )}
                  </WishlistItemCard>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Grid justifyContent="flex-end" container spacing={1.5}>
          <Grid item>
            <Button onClick={onCloseBtnClick} variant="default">
              Close
            </Button>
          </Grid>
          {hasApplicablePrograms && (
            <Grid item>
              <Button onClick={onApply} disabled={!scholarship.selectedProgramId?.toString()} variant="contained">
                Select Program and Apply
              </Button>
            </Grid>
          )}
        </Grid>
      </DialogActions>
    </>
  );
};

export default ApplyProgramSelect;
